import { FC, useContext, useEffect, useState } from 'react'
import { useIntl } from 'react-intl'

import { BarsOutlined } from '@ant-design/icons'
import { Button, List } from 'antd'

import { useRidersQuery } from '../../graphql'

import { Context } from './Context'
import { RiderCard } from './RiderCard'

const defaultPagination = { page: 1, pageSize: 24, total: 2094 }

const RidersList: FC<{ active: boolean }> = ({ active }) => {
  const { checked, country, rider, setChecked, setData } = useContext(Context)
  const [pagination, setPagination] = useState(defaultPagination)
  const { data, loading } = useRidersQuery({
    variables: {
      filters: {
        active: { eq: active },
        country: country ? { eq: country } : {},
        name: rider ? { containsi: rider } : {},
      },
      page: !rider && !country ? pagination.page : 1,
      pageSize: !rider && !country ? pagination.pageSize : 100,
    },
  })
  const [dataSource, setDataSource] = useState(data?.riders)
  const { formatMessage } = useIntl()

  useEffect(() => {
    if (country || rider) {
      if (country) {
        setDataSource((prevState) => (rider ? prevState : data?.riders)?.filter((it) => it?.country === country))
      }
      if (rider) {
        setDataSource((prevState) =>
          (country ? prevState : data?.riders)?.filter((it) => it?.name?.toLowerCase().includes(rider.toLowerCase())),
        )
      }
    } else {
      setDataSource(data?.riders)
    }
  }, [rider, country, data])

  const Action: FC<{ slug: string; onClick: VoidFunction }> = ({ slug, onClick }) => (
    <Button
      data-umami-event={`riders.compare.add.${slug}`}
      title={formatMessage({ id: 'riders.add-to-compare' })}
      icon={<BarsOutlined />}
      shape={'circle'}
      type={checked.find((i) => slug === i) ? 'primary' : 'default'}
      onClick={() => {
        if (checked.find((i) => slug === i) === undefined) {
          setChecked((prevState) => prevState.concat(slug))
        } else {
          setChecked((prevState) => prevState.filter((e) => e !== slug))
        }
        onClick()
      }}
    />
  )

  return (
    <List
      split={false}
      loading={loading}
      grid={{ gutter: 16, xs: 1, sm: 1, md: 2, lg: 2, xl: 3, xxl: 3 }}
      dataSource={dataSource}
      rowKey={(it) => `${it?.documentId}`}
      pagination={{
        hideOnSinglePage: true,
        current: pagination.page,
        pageSize: pagination.pageSize,
        responsive: true,
        showSizeChanger: false,
        total: active
          ? defaultPagination.pageSize
          : !rider && !country
            ? defaultPagination.total - defaultPagination.pageSize
            : data?.riders.length,
        onChange: (page, pageSize) => setPagination((prevState) => ({ ...prevState, page, pageSize })),
      }}
      renderItem={(it) => {
        return (
          it && (
            <List.Item>
              <RiderCard
                {...it}
                action={<Action slug={it.slug} onClick={() => setData((prevState) => prevState.concat(it))} />}
              />
            </List.Item>
          )
        )
      }}
    />
  )
}

export { RidersList }
